module.exports = __webpack_public_path__ + "static/media/logo.91f238c5.jpg";